import { urlBase64ToUint8Array, setCookie } from '/src/utils';
import { fetchPostQuery } from '/src/api';

const checkNotificationSupported = () => {
    return new Promise((fulfilled, reject) => {
        if (!('serviceWorker' in navigator)) {
            reject(new Error('Service workers are not supported by this browser'));
            return;
        }

        if (!('PushManager' in window)) {
            reject(new Error('Push notifications are not supported by this browser'));
            return;
        }

        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            reject(new Error('Notifications are not supported by this browser'));
            return;
        }
        fulfilled();
    })
};

const subscribeNotification = (applicationServerKey) => {
    navigator.serviceWorker.ready.then((sw) => {
        sw.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(applicationServerKey)
        }).then((subscription) => {
            fetchPostQuery({
                query: `mutation RegisterSubscription($subscription: String) {
                                        registerSubscription(subscription: $subscription)
                                    }`,
                variables: {subscription: JSON.stringify(subscription.toJSON())}
            }).catch(error => console.log(error));
            setCookie('subscription_endpoint', subscription.endpoint, 365);
        }).catch(error => console.log(error));
    });
};

const pushNotification = () => {
    fetchPostQuery({ query: `query PushNotification { 
            pushNotification {
                is_allowed
                server_key
                request_permission_delay
            }
        }`
    })
    .then((response) => {
        if (response?.pushNotification?.is_allowed) {
            const {server_key, request_permission_delay} = response.pushNotification;
            checkNotificationSupported().then(() => {
                if (Notification.permission === 'default') {
                    setTimeout(() => {
                        Notification.requestPermission().then((permission) => {
                            if (permission === 'granted') {
                                subscribeNotification(server_key);
                            } else {
                                navigator.permissions
                                    .query({name: 'notifications'})
                                    .then((permissionStatus) => {
                                        permissionStatus.onchange = () => {
                                            if (permissionStatus.state === 'granted') {
                                                subscribeNotification(server_key);
                                            }
                                        };
                                    });
                            }
                        });
                    }, request_permission_delay || 5000);
                }
            });
        }
    }, console.error)
    .catch(() => {});
};

export {
    pushNotification,
};
